import React from 'react';
import { useSelector } from 'react-redux';
import { getProductCardLabels } from '@yme/pdp-components/ProductCard';
import { getIsInAuthor, getRootLang, getRTL } from '@yme/selectors/common';
import { colorCoreBlack300, colorCoreBlack900Base } from '@yme/tokens/colors';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { ProductPart } from './ProductPart';
import { ProductPartContainerStyled, ProductPartTitleStyled, ScrollableContainer, WrapperStyled, } from './styled';
const MAX_ITEMS = 6;
export function ProductPartContainer({ data, title, description, viewDetailsLabel, privacyConsentsModel, }) {
    const isRightToLeft = useSelector(getRTL);
    const rootLanguage = useSelector(getRootLang);
    const isInAuthor = useSelector(getIsInAuthor);
    const { productCard_controlMethod_label: controlMethod, productCard_startingMethodAndTilt_label: startingMethod, productCard_shaftLength_label: shaftLength, productCard_rotation_label: rotation, productCard_colorSelector_label: colourName, product_size_label: size, } = useSelector(getProductCardLabels);
    const hasScroll = data?.length > MAX_ITEMS;
    const labels = {
        controlMethod,
        startingMethod,
        shaftLength,
        rotation,
        colourName,
        size,
    };
    if (!data?.length) {
        return null;
    }
    return (React.createElement(WrapperStyled, null,
        React.createElement(ProductPartTitleStyled, { color: colorCoreBlack900Base, weight: 500 }, title),
        React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, description),
        React.createElement(ProductPartContainerStyled, null,
            React.createElement(ScrollableContainer, { hasScroll: hasScroll, isRightToLeft: isRightToLeft }, data?.map((item) => (React.createElement(ProductPart, { key: item.id, item: item, labels: labels, viewDetailsLabel: viewDetailsLabel, rootLanguage: rootLanguage, isInAuthor: isInAuthor, isRightToLeft: isRightToLeft, privacyConsentsModel: privacyConsentsModel })))))));
}
